import { useEffect, useState } from "react";
import { formateDateTime } from "../../../utils";
import Avatar from "../../../static/images/avata.svg";
export const CustomCardMultiple = props => {
    return (
        <>
            {
                props.data.map((item) =>
                    <div class={'card ' + item.className} style={{ animation: 'fadeIn .3s' }} >
                        <div class="content-wrapper">
                            <div className="prd">
                                <img src="" alt="logo" />
                            </div>

                            <div class="prd-info">
                                <span>{item.productType}</span>
                                <h4>{item.productName}</h4>
                                <span class="prd-detail">{item.productOwner}</span>
                            </div>
                        </div>
                        <div class="policy-no">
                            <span>Policy Number</span>
                            <span>{item.policyNo}</span>
                        </div>
                    </div>
                )}
        </>
    )
};
export const CustomCardSingle = props => {
    const item = props.content;
    return (
        <div class={'card ' + props.className} style={{ animation: 'fadeIn .3s' }}>
            <div class="content-wrapper">
                <div className="prd">
                    <img src={item.display_logo} alt="logo" />
                </div>

                <div class="prd-info">
                    <span>{item.product_name}</span>
                    <h4>{item.display_value}</h4>
                    <span class="prd-detail">{item.display_discription}</span>
                </div>
            </div>
            {/* {item.ref_value && item.ref_key ?
                <div class="policy-no">
                    <span>{item.ref_key}</span>
                    <span>{item.ref_value}</span>
                </div>
                : null} */}
        </div>
    )
};

export const CustomCard = props => {
    const item = props.content;
    return (
        <div class={'card ' + props.className} style={{ animation: 'fadeIn .3s' }}>
            <div class="content-wrapper">
                <div className="prd">
                    <img src={item.display_logo} alt="logo" />
                </div>

                <div class="prd-info">
                    <span>{item.product_name}</span>
                    <h4>{item.display_value}</h4>
                    <span class="prd-detail">{item.display_discription}</span>
                </div>
            </div>
            {/* {item.ref_value && item.ref_key ?
                <div class="policy-no">
                    <span>{item.ref_key}</span>
                    <span>{item.ref_value}</span>
                </div>
                : null} */}
        </div>
    )
};



export const CardSelection = props => {
    const [viewMore, setViewMore] = useState(false)
    useEffect(() => {
        if (content.choices && content.choices.length > 2 && !props.message.selected) {
            setViewMore(true)
        }
    })
    const [count, setCount] = useState(-1);
    const [offset, setOffset] = useState(2)
    const changePage= ()=>{
        setOffset((offset)=> offset+3)
    }
    // console.log(offset, count)
    useEffect(()=>{
// if(content.choices.length>=offset){
    // props.scrollintoview(props?.id)
    props.scrollToBottom()
// }
    },[count, offset])
    useEffect(() => {
        props.GAEvent({ eventAction: "booking-listing", eventLabel: "display-listing" })
        // console.log(count)
        if (content.type && content.type === "BookingSelection" && props.message.selected) {
            setCount(9999)
        }
        else if (content.choices && content.choices.length > count && count < offset) {

            const interval = setInterval(() => {
                setCount((count)=> count + 1);
                // props.scrollintoview(props.id)
                props.scrollToBottom()
            }, 500);
            return () => clearInterval(interval);
        }
    }, [count, props.message.displayAllOptions, viewMore, offset]);
    const content = JSON.parse(props.message.content);
    return (
        <>
            {content.title ? (
                <>
                    <div class="grop_message">
                        <div
                            class="message"
                            dangerouslySetInnerHTML={{ __html: content.title }}
                        />
                    </div>

                    {/* <img class="grop_message blank">
                    </img>
                    <div class=" grop_message msg-detials">
                    PB Chat <i/>{formateDateTime(props.message.sentAt)}
                    </div> */}

                </>
            ) : null}
            <>
                {props.isHistoryMessgage ? null :
                    <div class={`product-info `}>

                        {content.choices.map((item1, index) => (
                            <>{index <= count ?
                                <>
                                    {props.message.displayAllOptions || index < count || !viewMore ?

                                        <div className={`card-item hidden ${props.agentName || item1.isActive === false ? "disabled": null} ${index + 1 <= count ? 'show' : null}`} onClick={() => {props.selectOption(item1, content.type, props.message.messageId)
                                           props.GAEvent ({eventAction:"booking-selected",eventLabel:item1.display_value})}} >
                                            <CustomCardSingle
                                                content={item1}
                                                className='white'
                                            />
                                        </div>
                                        :
                                        null}

                                </>
                                : null}
                            </>
                        ))}
                        {viewMore && !props.message.displayAllOptions && count >= 2 && content.choices.length>offset ?
                            <div class="card link" onClick={() => changePage()}>
                                <h4>Need help with another policy?</h4>
                            </div>
                            : null}
                    </div>
                }
            </>



        </>)

};

export const SingleCardSelection = props => {
    const [viewMore, setViewMore] = useState(false)
    useEffect(() => {
        if (content.choices && content.choices.length > 2 && !props.message.selected) {
            setViewMore(true)
        }
    })
    const [count, setCount] = useState(3);
    useEffect(() => {
        if (content.type && content.type === "BookingSelection" && props.message.selected) {
            setCount(9999)
        }
        else if (content.choices && content.choices.length > count && props.message.displayAllOptions || count < 3 || !viewMore) {

            const interval = setInterval(() => {
                setCount(count + 1);
                // props.scrollToBottom()
            }, 500);
            // scrollToBottom()
            return () => clearInterval(interval);
        }
    }, [count, props.message.displayAllOptions, viewMore]);
    const content = JSON.parse(props.message.content);
    return (
        <>
            {content.title ? (
                <>
                    <div class="grop_message">
                        <div
                            class="message"
                            dangerouslySetInnerHTML={{ __html: content.title }}
                        />
                    </div>

                </>
            ) : null}
            <>

                <div class="product-info" style={{ marginBottom: 0 }}>

                    {content.choices.map((item1, index) => (
                        <>{index <= count ?
                            <>
                                {props.message.displayAllOptions || index < 2 || !viewMore ?

                                    <div className={`card-item hidden ${index + 1 <= count ? 'show' : null}`} >
                                        <CustomCardSingle
                                            content={item1}
                                            className='balnk'
                                        />
                                    </div>
                                    :
                                    null}

                            </>
                            : null}
                        </>
                    ))}
                    {viewMore && !props.message.displayAllOptions && count > 2 ?
                        <div class="card link" onClick={() => props.displayAllOptions(props.message.messageId)}>
                            <h4>Need help with another policy?</h4>
                        </div>
                        : null}
                </div >
            </>



        </>)

};



